export enum Metrics {
  intents = 'Intent reports',
  companiesDiscovered = 'Companies discovered',
  contactsDiscovered = 'Contacts discovered',
  meetingBooked = 'Meetings booked',
  mcoActivities = 'MCO activities',
  targetPipelineValue = 'Target pipeline',
  digitalLeads = 'Digitally engaged contacts',
  highlyEngagedDeals = 'Highly engaged accounts',
  connectionRequestsSent = 'Connection requests sent',
  connectionRequestsAccepted = 'Connection requests accepted',
  impressions = 'Impressions',
  campaignClicks = 'Campaign clicks',
}

export enum UserStatus {
  'FORCE_CHANGE_PASSWORD' = 'INVITATION EMAIL SENT',
  'UNCONFIRMED' = 'USER CREATED BUT UNCONFIRMED',
  'CONFIRMED' = 'EMAIL VERIFIED',
  'EXTERNAL_PROVIDER' = 'SSO VERIFIED',
  'ARCHIVED' = 'NO LONGER ACTIVE',
  'UNKNOWN' = 'UNKNOWN',
  'RESET_REQUIRED' = 'USER CONFIRMED BUT RESET REQUIRED',
}

export const DEFAULT_CURRENCY = 'USD'
